import GitProvider from './GitProvider';
import { ProjectType } from './ProjectType';
import { UserContext } from './User';

export type AppPrivacySettingType = 'public' | 'private';

export type AppSortBy = 'created_at' | 'last_build_at';

export type App = {
  slug: string;
  title: string;
  type: ProjectType;
  projectId?: string;
  projectType?: ProjectType;
  avatarUrl: string;
  repositoryUrl: string;
  provider: GitProvider;
  defaultBranch?: string;
  gitRepoSlug: string;
  gitOwner: string;
  privacySetting: AppPrivacySettingType;
  isPublic: boolean;
  isDisabled?: boolean;
  owner?: {
    name?: string;
    slug: string;
    username?: string;
  };
  ownerAvatarUrl?: string;
  ownerName?: string;
  ownerType?: 'User' | 'Organization';
  ownerUsername?: string;
  hasAnyBuild?: boolean;
  usesRepositoryYml: boolean;
};
export type AppWithOwner = App & { owner: NonNullable<App['owner']> };
export type AppWithProject = AppWithOwner & { projectId: NonNullable<App['projectId']> };

export type PublicApiApp = {
  avatarUrl?: string;
  isDisabled: boolean;
  isPublic: boolean;
  owner: {
    accountType: string;
    name: string;
    slug: string;
  };
  projectId: string;
  projectType: ProjectType;
  provider: GitProvider;
  repoOwner: string;
  repoSlug: string;
  repoUrl: string;
  slug: string;
  status: number;
  title: string;
};

export type SimplePublicApiApp = Pick<PublicApiApp, 'slug' | 'title' | 'avatarUrl'> & {
  owner: { name: string };
};

export type OwnedApp = {
  privacySetting: AppPrivacySettingType;
  slug: string;
  title: string;
  type: ProjectType;
  avatarUrl: string;
};

export const viewedAsPublicPage = (isPublicApp: boolean, user?: UserContext) => isPublicApp && !user?.username;

export type RepositoryApp = {
  appleCredentialUserId: number | null;
  avatarIconUrl: string | null;
  branches: string[];
  gitOwner: string;
  gitRepoSlug: string;
  gitlabRepoId: string | null;
  isCurrentUserCanDestroy: boolean;
  isMachineTypeSelectorAvailable: boolean;
  isPublic: boolean;
  lastBuildAt: string | null;
  ownerName?: string;
  ownerUsername?: string;
  ownerType: string;
  ownerSlug: string;
  projectType: ProjectType | null;
  provider: string;
  servicesCredentialUserId: number | null;
  slug: string;
  stackData: {
    descriptionUrl: string;
    title: string;
  };
  status: number;
  teamMemberCount: number;
  title: string;
  url: string;
  defaultBranchName?: string;
  hasSshKeyPair?: boolean;
  hasGitHttpCredential?: boolean;
};
